import React from 'react';
import {LessonContentRecordVideo} from '../../../../../data/models/LessonContent/LessonContentBase';
import RecordVideoOptionsUI from '../view/RecordVideoOptionsUI';
import {lessonEditorText} from '../../../lessonEditorText';
import BaseOptionsContainer, {
  BaseContainerProps,
} from '../../BaseOptionsContainer';

interface Props extends BaseContainerProps {
  onReRecord: () => void;
}

export default React.memo(({onReRecord, ...props}: Props) => (
  <BaseOptionsContainer
    {...props}
    deleteMessage={lessonEditorText.areYouSureDeleteVideo}
    softDeleteMessage={lessonEditorText.areYouSureDeleteVideoSoft}>
    {forwardProps => (
      <RecordVideoOptionsUI
        {...forwardProps}
        entityToEdit={forwardProps.entityToEdit as LessonContentRecordVideo}
        onReRecord={onReRecord}
      />
    )}
  </BaseOptionsContainer>
));
